module.exports = __webpack_public_path__ + "static/media/16UNODC14.b4d3adfc.jpg";